export const config = {
  MapboxPublicKey: 'pk.eyJ1IjoiYmFsa2VybmUiLCJhIjoiY2wwdGswNDhpMDAzczNrbXY1aHE3dno5OSJ9.gmUFneco76pHw2FmprGpPw',
  GoogleMapsKey: "AIzaSyCPOQgTIkGiKuleo1CDM79DA2AqiY83AV4",
  SentryDSN: 'https://9e12c7ad7fc34e648a742689d74db57f@o399562.ingest.sentry.io/4504481081982976',
  BackendEndpointStatic: 'https://api.balkerne.com/prod',
}
